import { createSlice } from "@reduxjs/toolkit"

const initialData = {
    loadingTimingsRequest:false,
    loadingTimingsError:false,
    addTimingsRequest:false,
    addTimingsSuccess:false,
    addTimingsError:false,
    timings:[],
    timingsFull:[],
}

const timingReducer = createSlice({
    name:'timings',
    initialState:initialData,
    reducers:{
        loadingTimingsRequest(state){
            state.loadingTimingsRequest = true;
            state.timings = [];
            state.timingsFull = [];
            state.loadingTimingsError = false;
        },
        loadingTimingsSuccess(state,action){
            state.loadingTimingsRequest = false;
            state.timings = action.payload.map(e=>e.start_time);
            state.timingsFull = action.payload;
            state.loadingTimingsError = false;
        },
        loadingTimingsFail(state){
            state.loadingTimingsRequest = false;
            state.timings = [];
            state.timingsFull = [];
            state.loadingTimingsError = true;
        },
        addTimingsRequest(state){
            state.addTimingsRequest = true;
            // state.timings = [];
            // state.timingsFull = [];
            state.addTimingsSuccess = false;
            state.addTimingsError = false;
        },
        addTimingsSuccess(state){
            state.addTimingsRequest = false;
            state.addTimingsSuccess = true;
            // state.timings = [];
            // state.timingsFull = [];
            state.addTimingsError = false;
        },
        addTimingsFail(state){
            state.addTimingsSuccess = false;
            state.addTimingsRequest = false;
            // state.timings = [];
            // state.timingsFull = [];
            state.addTimingsError = true;
        },
        addTimeSlot(state,action){
            if(state.timings.includes(action.payload)){
                state.timings = state.timings.filter(e=>e!== action.payload);
            }else{
                state.timings.push(action.payload);
            }
        },
        addTimeSlotBulk(state,action){
            if(state.timings.includes(action.payload)){
                // state.timings = state.timings.filter(e=>e!== action.payload);
            }else{
                state.timings.push(action.payload);
            }
        },
        removeTimeSlot(state,action){
            if(state.timings.includes(action.payload)){
                // console.log(state.timings);
                state.timings = state.timings.filter(e=>e!== action.payload);
                // console.log(state.timings);
            }
            // else{
            //     state.timings.push(action.payload);
            // }
        },

        removeTimeSlotBulk(state){
            state.timings = [];
            state.timingsFull = [];
        },
    }
});

export default timingReducer.reducer;

export const {removeTimeSlotBulk,loadingTimingsRequest,loadingTimingsSuccess,loadingTimingsFail,addTimingsRequest,addTimingsSuccess,addTimingsFail,addTimeSlot,addTimeSlotBulk,removeTimeSlot} = timingReducer.actions;